export const ZOHO_CLIENT_ID = "1000.XE2UEHUE135BXQD10W2NXCMEL6SMVS";
export const ZOHO_SCOPE = "ZohoCRM.modules.leads.ALL,ZohoCRM.modules.contacts.ALL";
export const ZOHO_REDIRECT_URI = "https://beta.skalebot.com/marketplace/zoho/auth";
export const ZOHO_ACCESS_TYPE = "offline";
export const ZOHO_PROMPT = "consent";